export default class ClientFeedback {

    constructor() {
        this.settings = {
            el: document.getElementsByClassName('client-feedback')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        document.addEventListener('DOMContentLoaded', function() {
            $(document).ready(function() {
                $('.gform_wrapper select').on('select2:open', function() {
                    setTimeout(function() {
                        $('.select2-results__options li').each(function() {
                            if ($(this).text().trim() === '— select a Our People —') {
                                $(this).text('Our People');
                            }
                        });
                    }, 100);
                });
            });
        });
    }

};

new ClientFeedback();